module.exports = __webpack_public_path__ + "static/media/reactMovie_logo.08494abf.png";